import { render, staticRenderFns } from "./ZonaAmortecimentoUnidadeConservacaoPi.vue?vue&type=template&id=942fc9e6&lang=pug"
import script from "./ZonaAmortecimentoUnidadeConservacaoPi.vue?vue&type=script&lang=js"
export * from "./ZonaAmortecimentoUnidadeConservacaoPi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports